import { ResourceStatus, ResourceType } from "./enums";

export interface ResourceCallback
{
    (res:Resource):any
}

export class Resource
{
    public status:ResourceStatus = ResourceStatus.Empty;
    public type:ResourceType = ResourceType.Default;    
}